export default __webpack_public_path__ + "static/media/szafy9.c17d0555.jpg";